import React, { useCallback, useEffect, useState } from 'react';
import { orderApi, formatApiError } from '../../lib/orderApi';
import { goldButton, redButton } from '../PageShell';

const input = {
  background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.25)', color: '#F5F5F0',
  padding: '11px 13px', fontSize: '13px', outline: 'none',
};

const AdminDrivers = ({ isOpen }) => {
  const [drivers, setDrivers] = useState([]);
  const [form, setForm] = useState({ name: '', email: '' });
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await orderApi.get('/admin/drivers');
      setDrivers(data.drivers);
    } catch { setMsg('Error al cargar choferes'); }
  }, []);

  useEffect(() => { if (isOpen) load(); }, [isOpen, load]);

  const addDriver = async () => {
    if (!form.name.trim() || !form.email.trim()) { setMsg('Escribe nombre y email.'); return; }
    setBusy(true); setMsg('');
    try {
      await orderApi.post('/admin/drivers', { name: form.name.trim(), email: form.email.trim() });
      setMsg('✓ Invitación enviada por email con código de confirmación.');
      setForm({ name: '', email: '' });
      load();
    } catch (e) {
      setMsg('Error: ' + formatApiError(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  const resend = async (id) => {
    setMsg('');
    try {
      await orderApi.post(`/admin/drivers/${id}/resend`);
      setMsg('✓ Invitación reenviada.');
      load();
    } catch (e) { setMsg('Error: ' + formatApiError(e.response?.data?.detail)); }
  };

  const remove = async (id, name) => {
    if (!window.confirm(`¿Eliminar al chofer ${name}? Perderá acceso al portal.`)) return;
    setMsg('');
    try {
      await orderApi.delete(`/admin/drivers/${id}`);
      setMsg('✓ Chofer eliminado.');
      load();
    } catch (e) { setMsg('Error: ' + formatApiError(e.response?.data?.detail)); }
  };

  if (!isOpen) return null;

  return (
    <div className="mt-5 p-5" style={{ background: '#141414', border: '1px solid rgba(201,168,76,0.3)' }} data-testid="drivers-panel">
      <h3 className="font-display" style={{ fontSize: '18px', fontWeight: 700, color: '#F5F5F0' }}>Choferes</h3>
      <p className="font-body mt-1" style={{ fontSize: '12px', color: '#C2C1B6' }}>
        Al agregar un chofer se le envía una invitación por email con un link al portal (<span style={{ color: '#C9A84C' }}>/chofer</span>) y un código de confirmación.
        Cada vez que entre al sistema recibirá un código de 6 dígitos en su email.
      </p>

      <div className="flex gap-3 mt-4 flex-wrap">
        <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nombre del chofer" style={{ ...input, flex: 1, minWidth: '180px' }} data-testid="admin-driver-name" />
        <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="email@ejemplo.com" type="email" style={{ ...input, flex: 1, minWidth: '200px' }} data-testid="admin-driver-email" />
        <button onClick={addDriver} disabled={busy} style={{ ...redButton, padding: '12px 22px', opacity: busy ? 0.6 : 1 }} data-testid="admin-driver-add">
          {busy ? 'Enviando…' : 'Agregar y enviar invitación'}
        </button>
      </div>

      {msg && (
        <p className="font-body mt-3" style={{ fontSize: '12px', color: msg.startsWith('✓') ? '#7FB77E' : '#E0736F' }} data-testid="admin-driver-msg">{msg}</p>
      )}

      <div className="mt-5 space-y-2" data-testid="admin-drivers-list">
        {drivers.length === 0 && (
          <p className="font-body" style={{ fontSize: '13px', color: '#888880' }}>No hay choferes registrados.</p>
        )}
        {drivers.map((d) => (
          <div key={d.id} className="flex items-center justify-between flex-wrap gap-2 p-3" style={{ background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.15)' }} data-testid={`driver-row-${d.id}`}>
            <div>
              <span className="font-body" style={{ fontSize: '14px', fontWeight: 600, color: '#F5F5F0' }}>{d.name}</span>
              <span className="font-body ml-3" style={{ fontSize: '12px', color: '#C2C1B6' }}>{d.email}</span>
              <span className="font-body uppercase ml-3" style={{ fontSize: '10px', letterSpacing: '1.5px', padding: '2px 8px', color: d.active ? '#7FB77E' : '#C9A84C', border: `1px solid ${d.active ? 'rgba(127,183,126,0.5)' : 'rgba(201,168,76,0.4)'}` }}>
                {d.active ? 'Activo' : 'Invitado'}
              </span>
            </div>
            <div className="flex gap-2">
              <button onClick={() => resend(d.id)} style={{ ...goldButton, padding: '8px 14px', fontSize: '11px' }} data-testid={`driver-resend-${d.id}`}>
                Reenviar invitación
              </button>
              <button onClick={() => remove(d.id, d.name)} style={{ border: '1px solid rgba(200,40,43,0.6)', color: '#E0736F', background: 'transparent', padding: '8px 14px', fontSize: '11px', letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer' }} data-testid={`driver-delete-${d.id}`}>
                Eliminar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDrivers;
